import { stringLengthMax } from '../../utils/utilFunctions';

import StyledWrapper from './style';

import Tooltip from '@mui/material/Tooltip';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import LaunchIcon from '@mui/icons-material/Launch';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';

const VerticalNavLink = ({ active, text, onClick, isTeam, isBudget, isGoals }) => (
	<StyledWrapper.NavButton selected={active} onClick={onClick}>
		<ListItemIcon sx={{ width: '80px', justifyContent: 'right' }}></ListItemIcon>
		<ListItemText
			sx={{
				width: '220px',
				marginLeft: '16px',
				display: 'flex',
				alignItems: 'center'
			}}
		>
			<div style={{ display: 'flex' }}>
				{isTeam && <GroupAddIcon sx={{ color: 'rgba(0, 0, 0, 0.6)' }} />}
				{isBudget && <RequestQuoteIcon sx={{ color: 'rgba(0, 0, 0, 0.6)' }} />}
				{isGoals && <FlagCircleIcon sx={{ color: 'rgba(0, 0, 0, 0.6)' }} />}

				<Tooltip title={text.length > stringLengthMax ? text : ''} arrow placement="top">
					<StyledWrapper.NavText>{text}</StyledWrapper.NavText>
					{(isBudget || isGoals) && (
						<LaunchIcon
							viewBox="0 0 24 24 "
							sx={{ position: 'absolute', marginLeft: '2px', transform: 'scale(0.8)' }}
						/>
					)}
				</Tooltip>
			</div>
		</ListItemText>
	</StyledWrapper.NavButton>
);

export default VerticalNavLink;
